import {
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { DataContext } from "../../../Context/ContextWrapper";
import dayjs from "dayjs";
import { printPDF, stpModuli } from "../../../../../../networking";
import summaryImg from "../../../../../../assets/Registration Confirmed.svg";
import Tooltip from "@mui/material/Tooltip";
import PrintFormsTable from "./PrintFormsTable";
import { GridSelectionModel } from "@mui/x-data-grid";

type ModuleRow = {
  id: string;
  nome: string;
  descrizione: string;
  tipoModulo: string;
  tipoStampa: string;
};

const SummaryTable = ({
  handleShowDetailedSummary,
  appointmentDetails,
}: {
  handleShowDetailedSummary: () => void;
  appointmentDetails: any;
}) => {
  const context = useContext(DataContext);

  // Stato per mostrare la tabella dei moduli da stampare
  const [showPrintFormsTable, setShowPrintFormsTable] =
    useState<boolean>(false);
  const [selectedModuleIds, setSelectedModuleIds] =
    useState<GridSelectionModel>([]);

  const [selectedModules, setSelectedModules] = useState<ModuleRow[]>([]);

  useEffect(() => {
    console.log("Appuntamenti ricevuti dal context", context?.appointmentsList);
  }, [context?.appointmentsList]);

  // const handlePrintPdf = async (numeroPrenotazione: string) => {
  //   try {
  //     const response = await printPDF({ numPren: numeroPrenotazione });

  //     if (response.data.esito !== "OK" || !response.data.risposta.pdfBase64) {
  //       throw new Error("Errore nella generazione del PDF");
  //     }

  //     const byteCharacters = atob(response.data.risposta.pdfBase64);
  //     const byteNumbers = new Array(byteCharacters.length);
  //     for (let i = 0; i < byteCharacters.length; i++) {
  //       byteNumbers[i] = byteCharacters.charCodeAt(i);
  //     }
  //     const byteArray = new Uint8Array(byteNumbers);

  //     const blob = new Blob([byteArray], { type: "application/pdf" });

  //     const link = document.createElement("a");
  //     link.href = URL.createObjectURL(blob);
  //     link.download = `prenotazione_${numeroPrenotazione}.pdf`;
  //     document.body.appendChild(link);
  //     link.click();

  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(link.href);
  //   } catch (error) {
  //     console.error("Errore nel download del PDF:", error);
  //   }
  // };

  const sortedData = useMemo(() => {
    return [...(context?.appointmentsList ?? [])]
      .filter((a) => !!a.data && !!a.ora)
      .sort((a, b) => {
        const aDateTime = dayjs(`${a.data} ${a.ora}`, [
          "YYYY-MM-DD HH:mm",
          "DD/MM/YYYY HH:mm",
        ]);
        const bDateTime = dayjs(`${b.data} ${b.ora}`, [
          "YYYY-MM-DD HH:mm",
          "DD/MM/YYYY HH:mm",
        ]);

        if (!aDateTime.isValid() || !bDateTime.isValid()) return 0;

        return aDateTime.valueOf() - bDateTime.valueOf();
      });
  }, [context?.appointmentsList]);

  const totalImporto = (context?.appointmentsList ?? []).reduce((acc, curr) => {
    const importo = parseFloat(
      curr.importo?.toString().replace(",", ".") || "0"
    );
    return acc + (isNaN(importo) ? 0 : importo);
  }, 0);

  const singleImporto = parseFloat(
    appointmentDetails?.importo?.toString().replace(",", ".") || "0"
  );

  const totalImportoFinal = context?.appointmentsList?.length
    ? totalImporto
    : singleImporto;

  // Funzione per scaricare il PDF da una stringa Base64 (Viene usata in handlePrintSubmit con l'api stpModuli)
  const downloadPdfFromBase64 = (pdfB64: string, filename: string) => {
    // Decodifica la stringa Base64
    const byteCharacters = atob(pdfB64);
    // Crea un array di byte
    const byteNumbers = new Array(byteCharacters.length);
    // Popola l'array con i valori ASCII
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    // Crea un Uint8Array dai numeri byte
    const byteArray = new Uint8Array(byteNumbers);

    // Crea un Blob(ovvero un file che rappresenta un PDF) dal byte array
    const blob = new Blob([byteArray], { type: "application/pdf" });
    // Crea un link temporaneo per il download
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  };

  const handlePrintSubmit = async () => {
    try {
      if (selectedModules.length === 0) return;

      const payload = {
        aziendaElaborazione: context?.aziendaPrenotazione,
        procedura: "01",
        idAnapaz: context?.pazienteDataSingolo?.IDPAZIENTE ?? "",
        idRiferimento: context?.idPacate,
        moduli: selectedModules.map((m) => ({
          idParstad: m.id,
          tipoModulo: m.tipoModulo,
          tipoStampa: m.tipoStampa,
        })),
      };

      console.log("Payload stpModuli:", payload);
      console.log({ context });
      const response = await stpModuli(payload);

      const dati = response.data?.dati ?? [];

      console.log({ dati });

      const pdfB64 = dati.find((x: any) => x?.pdfB64)?.pdfB64;

      if (!pdfB64) {
        console.error("stpModuli: pdfB64 non presente", response.data);
        return;
      }

      downloadPdfFromBase64(
        pdfB64,
        `${context?.numeroAppuntamentoRiepilogo}.pdf`
      );
    } catch (error) {
      console.error("Errore stampa moduli:", error);
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          padding: 4,
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: 24,
          maxWidth: 800,
          width: "100%",
          maxHeight: "90vh",
        }}
      >
        {/* TITOLO */}
        {!showPrintFormsTable && (
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              marginBottom: 2,
              textAlign: "left",
              color: "#01579B",
            }}
          >
            Scheda Riepilogo Prenotazione
          </Typography>
        )}
        {showPrintFormsTable && (
          <Typography
            variant="h6"
            sx={{
              fontWeight: 500,
              font: "Rubik",
              fontSize: "20px",
              marginBottom: 2,
              textAlign: "left",
              color: "#01579B",
              lineHeight: "160%",
              letterSpacing: "0.15px",
            }}
          >
            Selezione Stampe
          </Typography>
        )}

        <Box
          sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}
        >
          <img src={summaryImg} alt="" />
        </Box>

        {/* DETTAGLI PRENOTAZIONE */}
        <Box
          sx={{
            backgroundColor: "#F4F4F4",
            padding: 2,
            borderRadius: "4px",
            marginBottom: 2,
            border: "1px solid rgba(204, 204, 204, 0.80)",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} sm={4}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography fontWeight="bold" color="#01579B">
                  Numero Prenotazione
                </Typography>
                <Typography>{context?.numeroAppuntamentoRiepilogo}</Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4} sm={4}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography fontWeight="bold" color="#01579B">
                  Data Prenotazione
                </Typography>
                <Typography>{dayjs().format("DD/MM/YYYY")}</Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4} sm={4}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography fontWeight="bold" color="#01579B">
                  Nominativo Paziente
                </Typography>
                <Typography>
                  {appointmentDetails?.cognomePaziente}{" "}
                  {appointmentDetails?.nomePaziente}
                </Typography>
              </Box>
            </Grid>

            {!showPrintFormsTable && (
              <>
                <Grid item xs={12} md={4} sm={4}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography fontWeight="bold" color="#01579B">
                      Operatore
                    </Typography>
                    <Typography>
                      {appointmentDetails?.codiceOperatore || "CUPS"}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} md={4} sm={4}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography fontWeight="bold" color="#01579B">
                      Ente
                    </Typography>
                    <Typography>{context?.ente || "-"}</Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} md={4} sm={4}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography fontWeight="bold" color="#01579B">
                      Tipologia Agenda
                    </Typography>
                    <Typography>
                      {appointmentDetails?.descrizioneTipoAgenda}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} md={4} sm={4}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography fontWeight="bold" color="#01579B">
                      Prezzo
                    </Typography>
                    <Typography>{totalImportoFinal.toFixed(2)} €</Typography>
                  </Box>
                </Grid>

                <Grid item md={12}>
                  <TableContainer
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignSelf: "stretch",
                      borderRadius: "4px",
                      borderTop: "1px solid #CCC",
                      borderBottom: "1px solid #CCC",
                      background: "#F9F9F9",
                      marginTop: 2,
                      overflow: "auto",
                      maxHeight: "200px",
                    }}
                  >
                    <Table sx={{ tableLayout: "fixed", minWidth: 600 }}>
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: "#E0E0E0 !important" }}
                        >
                          <TableCell
                            sx={{
                              background: "rgba(0, 0, 0, 0.00)",
                              borderRight: "1px solid #CCC",
                              borderLeft: "1px solid #CCC",
                              borderBottom: "1px solid #CCC",
                              color: "#000000",
                              fontStyle: "normal",
                            }}
                          >
                            Prestazione
                          </TableCell>
                          <TableCell
                            sx={{
                              background: "rgba(0, 0, 0, 0.00)",
                              borderRight: "1px solid #CCC",
                              borderLeft: "1px solid #CCC",
                              borderBottom: "1px solid #CCC",
                              color: "#000000",
                              fontStyle: "normal",
                            }}
                          >
                            Medico
                          </TableCell>
                          <TableCell
                            sx={{
                              background: "rgba(0, 0, 0, 0.00)",
                              borderRight: "1px solid #CCC",
                              borderLeft: "1px solid #CCC",
                              borderBottom: "1px solid #CCC",
                              color: "#000000",
                              fontStyle: "normal",
                            }}
                          >
                            Data
                          </TableCell>
                          <TableCell
                            sx={{
                              background: "rgba(0, 0, 0, 0.00)",
                              borderRight: "1px solid #CCC",
                              borderLeft: "1px solid #CCC",
                              borderBottom: "1px solid #CCC",
                              color: "#000000",
                              fontStyle: "normal",
                            }}
                          >
                            Ora
                          </TableCell>
                          <TableCell
                            sx={{
                              background: "rgba(0, 0, 0, 0.00)",
                              borderRight: "1px solid #CCC",
                              borderLeft: "1px solid #CCC",
                              borderBottom: "1px solid #CCC",
                              color: "#000000",
                              fontStyle: "normal",
                            }}
                          >
                            Durata
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {sortedData?.map((appointment, index) => (
                          <TableRow key={index}>
                            <Tooltip
                              title={appointment.descrizionePrestazione}
                              placement="top-start"
                            >
                              <TableCell
                                sx={{
                                  maxWidth: 180,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  borderRight: "1px solid #CCC",
                                  borderLeft: "1px solid #CCC",
                                }}
                              >
                                {appointment.descrizionePrestazione}
                              </TableCell>
                            </Tooltip>
                            <Tooltip
                              title={appointment.nominativoMedico}
                              placement="top-start"
                            >
                              <TableCell
                                sx={{
                                  maxWidth: 160,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  borderRight: "1px solid #CCC",
                                }}
                              >
                                {appointment.nominativoMedico}
                              </TableCell>
                            </Tooltip>
                            <TableCell sx={{ borderRight: "1px solid #CCC" }}>
                              {dayjs(appointment.data).format("DD/MM/YYYY")}
                            </TableCell>
                            <TableCell sx={{ borderRight: "1px solid #CCC" }}>
                              {appointment.ora}
                            </TableCell>
                            <TableCell sx={{ borderRight: "1px solid #CCC" }}>
                              {appointment.durata} Minuti
                            </TableCell>
                          </TableRow>
                        ))}

                        {!context?.appointmentsList?.length && (
                          <TableRow>
                            <Tooltip
                              title={appointmentDetails?.descrizionePrestazione}
                              placement="top-start"
                            >
                              <TableCell
                                sx={{
                                  maxWidth: 180,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  borderRight: "1px solid #CCC",
                                  borderLeft: "1px solid #CCC",
                                }}
                              >
                                {appointmentDetails?.descrizionePrestazione}
                              </TableCell>
                            </Tooltip>
                            <Tooltip
                              title={appointmentDetails?.nominativoMedico}
                              placement="top-start"
                            >
                              <TableCell
                                sx={{
                                  maxWidth: 160,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  borderRight: "1px solid #CCC",
                                }}
                              >
                                {appointmentDetails?.nominativoMedico}
                              </TableCell>
                            </Tooltip>
                            <TableCell sx={{ borderRight: "1px solid #CCC" }}>
                              {dayjs(appointmentDetails?.data).format(
                                "DD/MM/YYYY"
                              )}
                            </TableCell>
                            <TableCell sx={{ borderRight: "1px solid #CCC" }}>
                              {appointmentDetails?.ora}
                            </TableCell>
                            <TableCell sx={{ borderRight: "1px solid #CCC" }}>
                              {appointmentDetails?.durata} Minuti
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </>
            )}

            {showPrintFormsTable && (
              <>
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <PrintFormsTable
                    selection={selectedModuleIds}
                    onSelectionChange={(ids, rows) => {
                      setSelectedModuleIds(ids);
                      setSelectedModules(rows);
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Box>

        {!showPrintFormsTable && (
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            sx={{ marginTop: 2 }}
          >
            <Grid item>
              <Button
                variant="outlined"
                sx={{
                  borderColor: "#2E83C4",
                  color: "#2E83C4",
                  "&:hover": { backgroundColor: "#2E83C4", color: "white" },
                }}
                onClick={() => {
                  setShowPrintFormsTable(true);
                }}
              >
                Stampa
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#2E83C4" }}
                onClick={handleShowDetailedSummary}
              >
                Chiudi
              </Button>
            </Grid>
          </Grid>
        )}

        {showPrintFormsTable && (
          <Grid container justifyContent="space-between" sx={{ mt: 2 }}>
            <Grid item>
              <Button
                variant="outlinedError"
                onClick={() => setShowPrintFormsTable(false)} // Uscita: torna alla tabella appuntamenti
              >
                Uscita
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                disabled={selectedModules.length === 0}
                sx={{
                  backgroundColor:
                    selectedModules.length === 0 ? "#D3D7DB" : "#2E83C4",
                  boxShadow: "none",
                }}
                onClick={handlePrintSubmit}
              >
                Conferma
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Box>
  );
};

export default SummaryTable;
